import { isEmpty, equals, filter, slice, length } from "ramda";
import { countryCode } from "src/components/EditablePhoneNumberTextField/areacode";
import { normalizeNumber } from "src/utilities/formatNumbers"


export const isValidMobile = (value: any) => {
    const isAreaCode = slice(0, 3, value);
    const dialCode = isAreaCode;
    const areaCodes = filter((e: any) => equals(e, dialCode), countryCode);
    const normalizedNumber:any=normalizeNumber(value)
    const isValid = equals(length(normalizedNumber), 10)
    if (isEmpty(areaCodes) && !isEmpty(value)) {
        return 'Invalid area code';
    } else if (!isValid) {
        return 'Enter valid phone number';
    } else {
        return false
    }
}
